(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["holbrook-pickup"] && !Shopify.designMode) return;
  try {
    function holbrookPickupState(instant) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(instant).map(part => [part.type, part.value]));
    const minute = Number(parts.hour) * 60 + Number(parts.minute);
    const cutoff = parts.weekday === 'Sun' ? 1170 : 1200;
    if (!Number.isFinite(minute)) throw new Error('Invalid pickup time');
    return { open: minute >= 660 && minute < cutoff, beforeOpen: minute < 660, sunday: parts.weekday === 'Sun' };
  }

  if (!customElements.get('holbrook-pickup')) {
    customElements.define('holbrook-pickup', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        document.documentElement.classList.add('holbrook-pickup-enabled');
        this.refresh = () => this.render();
        this.intercept = event => {
          const target = event.target instanceof Element ? event.target : null;
          const checkoutControl = target?.closest('[name="checkout"], a[href]');
          let checkout = checkoutControl?.getAttribute('name') === 'checkout';
          if (checkoutControl?.tagName === 'A') {
            const url = new URL(checkoutControl.getAttribute('href'), location.origin);
            checkout = url.origin === location.origin && /\/(checkouts?|wallets)(\/|$)/.test(url.pathname);
          }
          if (event.type === 'submit') checkout = this.isCartForm(target) || /\/checkout\/?$/.test(target?.getAttribute('action') || '');
          if (!checkout) return;
          this.render();
          if (this.isOpen) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const message = document.querySelector('.holbrook-pickup__cart') || this.querySelector('[role="status"]');
          message?.setAttribute('tabindex', '-1');
          message?.focus();
          message?.scrollIntoView({ block: 'center', behavior: 'auto' });
        };
        document.addEventListener('click', this.intercept, true);
        document.addEventListener('submit', this.intercept, true);
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.refresh);
        this.observer = new MutationObserver(() => {
          if (this.pending) return;
          this.pending = requestAnimationFrame(() => { this.pending = 0; this.render(); });
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.timer = setInterval(this.refresh, 1000);
        this.render();
      }

      isCartForm(element) {
        if (element?.tagName !== 'FORM') return false;
        try {
          const action = new URL(element.getAttribute('action'), location.origin);
          return action.origin === location.origin && action.pathname.replace(/\/$/, '') === this.dataset.cartPath.replace(/\/$/, '');
        } catch { return false; }
      }

      render() {
        let state;
        try { state = holbrookPickupState(new Date()); } catch { state = { open: false, unknown: true }; }
        this.isOpen = state.open;
        const status = state.unknown ? this.dataset.unknown : state.open ? this.dataset.open : state.beforeOpen ? this.dataset.before : this.dataset.after;
        const cutoff = state.sunday ? this.dataset.sundayCutoff : this.dataset.weekdayCutoff;
        const detail = state.open ? this.dataset.cutoff.replace('[time]', cutoff) : this.dataset.location;
        const update = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
        update(this.querySelector('.holbrook-pickup__status'), status);
        update(this.querySelector('.holbrook-pickup__detail'), detail);
        this.dataset.state = state.open ? 'open' : 'closed';
        document.documentElement.classList.toggle('holbrook-pickup-closed', !state.open);
        for (const button of document.querySelectorAll('[name="checkout"]')) {
          if (!button.parentElement) continue;
          button.parentElement.classList.add('holbrook-pickup-checkout');
          let note = button.parentElement.querySelector('.holbrook-pickup__cart');
          if (!note) {
            note = document.createElement('p');
            note.className = 'holbrook-pickup__cart';
            note.setAttribute('role', 'status');
            note.setAttribute('aria-live', 'polite');
            button.before(note);
          }
          update(note, `${this.dataset.label} · ${status} ${detail}`);
          if (!state.open && !button.hasAttribute('data-holbrook-aria')) {
            button.dataset.holbrookAria = button.getAttribute('aria-disabled') || '';
            button.setAttribute('aria-disabled', 'true');
          } else if (state.open && button.hasAttribute('data-holbrook-aria')) {
            const previous = button.dataset.holbrookAria;
            previous ? button.setAttribute('aria-disabled', previous) : button.removeAttribute('aria-disabled');
            delete button.dataset.holbrookAria;
          }
        }
        for (const form of document.forms) {
          if (!this.isCartForm(form)) continue;
          for (const [key, value] of Object.entries({ 'Holbrook pickup': this.dataset.method, 'Usual preparation': this.dataset.estimate })) {
            const name = `attributes[${key}]`;
            let input = Array.from(form.elements).find(element => element.name === name);
            if (!input) {
              input = document.createElement('input');
              input.type = 'hidden';
              input.name = name;
              form.append(input);
            }
            input.value = value;
          }
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        cancelAnimationFrame(this.pending);
        this.observer?.disconnect();
        document.removeEventListener('click', this.intercept, true);
        document.removeEventListener('submit', this.intercept, true);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
        this.started = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
